import RenderersPluginSetup from "./renderers/PluginSetup.js";
import ValidatorsPluginSetup from "./validators/PluginSetup.js";
import EditorsPluginSetup from "./editors/PluginSetup.js";
import EquipmentCalculatedAlerts from "./attributes/EquipmentCalculatedAlerts.js";
import LocatorEquipment from "./attributes/LocatorEquipment.js";
import AssetTag from "./attributes/AssetTag.js";
import TagAsset from "./attributes/TagAsset.js";
import FiltersPluginSetup from "./filters/PluginSetup.js";
export default {
  install: molten => {
    RenderersPluginSetup.install(molten);
    ValidatorsPluginSetup.install(molten);
    EditorsPluginSetup.install(molten);
    FiltersPluginSetup.install(molten);
    molten.addPlugin('Attribute', EquipmentCalculatedAlerts);
    molten.addPlugin('Attribute', LocatorEquipment);
    molten.addPlugin('Attribute', AssetTag);
    molten.addPlugin('Attribute', TagAsset);
    molten.addPlugin('Attribute', {
      id: 'assetLocators.swatchAndColor',
      name: 'assetLocators.swatchAndColor',
      displayName: 'Swatch and Color',
      valueType: 'string',
      objectType: 'assetLocators',
      placement: {},
      get: obj => {
        return obj?.data?.color;
      },
      blueprint: {
        field: 'data/color'
      }
    });
    molten.addPlugin('Attribute', {
      id: 'assetLocators.openInJohnDeereButton',
      name: 'assetLocators.openInJohnDeereButton',
      displayName: 'Open In John Deere',
      valueType: 'string',
      objectType: 'assetLocators',
      placement: {},
      // Note: Dummy field, totally unrelated. Necessary for getting the displayName to show
      // up everywhere we want
      get: obj => {
        return obj?.data?.color;
      },
      blueprint: {
        field: 'data/color'
      }
    });
  }
};